import { NextSeo } from 'next-seo';
import { DEFAULT_SEO_CONFIG, ROOT_URL } from 'next-seo.config';

import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { Portfolio } from '@/components/Portfolio';

import { routes } from '@/utils/routes';

const PORTFOLIO_PAGE_TITLE = 'Portfolio | Matcha DEX aggregator';
const PORTFOLIO_PAGE_DESCRIPTION =
  'View your token balances across all supported chains. Track your portfolio value in real-time with Matcha.';

function PortfolioPage() {
  const canonicalUrl = `${ROOT_URL}${routes.PORTFOLIO}`;

  return (
    <>
      <NextSeo
        {...DEFAULT_SEO_CONFIG}
        title={PORTFOLIO_PAGE_TITLE}
        description={PORTFOLIO_PAGE_DESCRIPTION}
        canonical={canonicalUrl}
        openGraph={{
          title: PORTFOLIO_PAGE_TITLE,
          description: PORTFOLIO_PAGE_DESCRIPTION,
          images: [
            {
              url: `${ROOT_URL}/images/og/social-banner.jpg`,
              width: 1200,
              height: 630,
              alt: 'Matcha',
            },
          ],
        }}
        additionalMetaTags={[
          {
            name: 'twitter:title',
            content: PORTFOLIO_PAGE_TITLE,
          },
          {
            name: 'twitter:description',
            content: PORTFOLIO_PAGE_DESCRIPTION,
          },
          {
            name: 'twitter:image',
            content: `${ROOT_URL}/images/og/social-banner.jpg`,
          },
        ]}
      />
      <Header />
      <Portfolio />
      <Footer />
    </>
  );
}

export default PortfolioPage;
